import TopHeading from "./TopHeading";

export default TopHeading;
